<template>
  <div class="w-full lg:w-1/2 mx-auto">
    <div class="bg-white border rounded-md shadow-sm p-8">
      <div class="flex items-center gap-10">
        <div>
          <i class="fa-light fa-earth-africa block !w-full !h-auto" />
        </div>

        <div>
          <h1 class="mb-4 lg:mb-6">
            Server Error
          </h1>

          <p>
            Our server encountered an issue and could not process your request.
            This is not a temporary glitch. Please report this error to COGTA.
          </p>
          <p>
            Unfortunately, the data you were entering was not saved.
          </p>

          <RouterLink
            :to="{ name: 'app_default' }"
            class="btn btn-solid btn-secondary"
          >
            <i class="fa-regular fa-arrow-left" />
            <span class="">Return Home</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
